var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17647 15.8824V13.7647H10.6941C11.8059 13.7647 12.7722 13.4118 13.5932 12.7059C14.4141 12 14.8242 11.1176 14.8235 10.0588C14.8228 9 14.4127 8.11765 13.5932 7.41176C12.7736 6.70588 11.8073 6.35294 10.6941 6.35294H4.02353L6.77647 9.10588L5.29412 10.5882L0 5.29412L5.29412 0L6.77647 1.48235L4.02353 4.23529H10.6941C12.4059 4.23529 13.8752 4.79118 15.102 5.90294C16.3288 7.01471 16.9419 8.4 16.9412 10.0588C16.9405 11.7176 16.3274 13.1029 15.102 14.2147C13.8766 15.3265 12.4073 15.8824 10.6941 15.8824H3.17647Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9c02cb14ef59bb3281a8e5ffe35cf192.svg";
export { ForwardRef as ReactComponent };